export const logo = '/assets/sierraQMS-logo@2x.png';

export default logo;
